import React from "react";
import OurTeamContent from "./OurTeamContent";
import MainLayout from "../../layouts/MainLayout";

export default function OurTeam() {
  return (
    <MainLayout>
      <OurTeamContent />
    </MainLayout>
  );
}
